var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantinumNewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_10)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M5.47009 0.584375C5.68102 0.298437 6.01852 0.125 6.37477 0.125H17.6248C17.981 0.125 18.3185 0.29375 18.5295 0.584375L23.7795 7.70938C24.0982 8.14062 24.0654 8.73594 23.7091 9.13437L12.8341 21.1344C12.6232 21.3688 12.3185 21.5047 11.9998 21.5047C11.681 21.5047 11.381 21.3688 11.1654 21.1344L0.290398 9.13437C-0.0705391 8.73594 -0.0986641 8.14062 0.220086 7.70938L5.47009 0.584375ZM7.27477 2.45C7.12009 2.56719 7.0779 2.77812 7.17634 2.94219L9.86696 7.42344L2.96696 8C2.77477 8.01406 2.62477 8.17813 2.62477 8.375C2.62477 8.57187 2.77477 8.73125 2.96696 8.75L11.967 9.5C11.9857 9.5 12.0091 9.5 12.0279 9.5L21.0279 8.75C21.2201 8.73594 21.3701 8.57187 21.3701 8.375C21.3701 8.17813 21.2201 8.01875 21.0279 8L14.1326 7.42813L16.8232 2.94687C16.9216 2.78281 16.8795 2.56719 16.7248 2.45469C16.5701 2.34219 16.3545 2.36094 16.2232 2.50156L11.9998 7.07187L7.77634 2.49687C7.64509 2.35625 7.42946 2.3375 7.27477 2.45Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantinumNewImage);
export default __webpack_public_path__ + "static/media/plantinum--new-image.6357d81fab386aae5539a9741fb3caa5.svg";
export { ForwardRef as ReactComponent };